<template>
  <v-form v-model="form">
    <v-card>
      <v-card-text>
        <v-text-field
          v-model="password"
          label="Wachtwoord"
          placeholder="Wachtwoord"
          :type="show_pw ? 'text' : 'password'"
          :append-icon="show_pw ? 'mdi-eye' : 'mdi-eye-off'"
          :error-messages="errorMessage"
          :rules="[rules.required, rules.minsize]"
          outlined
          dense
          @click:append="show_pw = !show_pw"
          @focus="errorMessage = ''"
        ></v-text-field>
        <v-text-field
          v-model="repeat_password"
          label="Herhaal wachtwoord"
          placeholder="Herhaal wachtwoord"
          :type="show_pw ? 'text' : 'password'"
          :append-icon="show_pw ? 'mdi-eye' : 'mdi-eye-off'"
          :error-messages="errorMessage"
          :rules="[rules.required, rules.minsize]"
          outlined
          dense
          @click:append="show_pw = !show_pw"
        ></v-text-field>
      </v-card-text>
    </v-card>
    <v-btn
      class="mt-2"
      block
      bottom
      color="primary"
      :disabled="!valid"
      @click="submit"
    >
      Wachtwoord bijwerken
    </v-btn>
  </v-form>
</template>

<script>
import { useUsersStoreRefactor } from "@/stores/usersStoreRefactor";

export default {
  name: "UserPasswordForm",
  props: ["user"],
  emits: ["saved"],
  setup() {
    const usersStore = useUsersStoreRefactor();
    return { usersStore };
  },
  data() {
    return {
      show_pw: false,
      password: "",
      form: true,
      repeat_password: "",
      errorMessage: "",
      rules: {
        required: (value) => !!value || "Wachtwoord is verplicht.",
        minsize: (value) => value.length >= 8 || "Minimaal 8 karakters",
      },
    };
  },
  computed: {
    valid() {
      if (this.password == this.repeat_password && this.password.length >= 8) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async submit() {
      if (this.password == this.repeat_password) {
        try {
          await this.usersStore.changePassword(this.user, this.password);
          // Emit saved event to close the form dialog
          this.$emit("saved");
        } catch (error) {
          console.error("Error changing password:", error);
          this.errorMessage = "Er is een fout opgetreden bij het wijzigen van het wachtwoord";
        }
      } else {
        this.errorMessage = "De wachtwoorden komen niet overeen";
        this.password = "";
        this.repeat_password = "";
      }
    },
  },
};
</script>
